module.exports = __webpack_public_path__ + "img/any-mbg10.2dcd86ec.png";